import PropTypes from "prop-types"
import { getCSSVar } from "shared/lib/utils"

export default function XIcon({ width, height, color, strokeWidth }) {
  // Brand primary-dark from the CSS custom property; falls back to #111 when the token
  // stylesheet isn't loaded (e.g. tests). Resolved at render so the CSS var is ready.
  const stroke = color || getCSSVar("primary-text") || "#111"
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Close icon</title>
      <g
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="square"
      >
        <path d="M1.598 1.598l7.717 7.717M9.447 1.598L1.73 9.315" />
      </g>
    </svg>
  )
}

XIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
}

XIcon.defaultProps = {
  width: "11",
  height: "11",
  strokeWidth: "2",
}
